// Shared input validation for the registration form and admin guest editor.

export const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validatePhone = (phone) => {
  return phone.replace(/\D/g, '').length >= 10;
};
